import React, { PureComponent } from 'react';
import { Modal } from 'react-bootstrap';
import { i18n } from 'core/i18n';
const { formatText } = i18n;
import { recordEvent } from 'utilities/uTagging';
import { BASE_PATH } from 'constants/index';
import { history } from 'routes/history';

class OTPAlternativeOptionModal extends PureComponent {
    state = {
        countDown: 10,
    };
    constructor(props) {
        super(props);
        this.intervalRef = React.createRef();
    }

    componentDidMount() {
        this.intervalRef.current = setInterval(() => {
            if (this.state.countDown > 0) {
                this.setState(prevState => ({
                    countDown: prevState.countDown - 1,
                }));
            } else {
                this.logout();
                recordEvent(
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    {
                        accionEvento: 'otp-ibanid/modal-espera-transferencia',
                        etiquetaEvento: 'logout/time-over',
                        categoriaEvento: 'eventos IBAN OTP',
                    }
                );
            }
        }, 1000);
    }

    componentWillUnmount() {
        this.stopTimer();
    }

    stopTimer = () => {
        clearInterval(this.intervalRef.current);
    };

    logout = () => {
        this.stopTimer();
        this.props.finishStep();
        history.push(BASE_PATH + '/logout');
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            nombrePagina: '/onboarding/documentacion/finalizado-transferencia/',
            tipoProceso: 'onboarding',
            pasoProceso: 'documentacion',
            detalleProceso: 'finalizado-transferencia',
        });
    };

    handleClickUnderstandButton = () => {
        this.logout();
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid/modal-espera-transferencia',
            etiquetaEvento: 'entendido',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };
    handleClickCancelButton = () => {
        this.props.finishStep();
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid/modal-espera-transferencia',
            etiquetaEvento: 'cancelar cambio',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };

    render() {
        const { showModal, hideModal } = this.props;
        const { countDown } = this.state;
        return (
            <div>
                <Modal
                    show={showModal}
                    onHide={hideModal}
                    dialogClassName="otp-help-modal"
                    backdrop="static"
                    keyboard={false}
                    animation={false}
                >
                    <Modal.Body>
                        <h3 className="font-heading3">{formatText('otpCode-transferModalTitle1')}</h3>
                        <div className="otp-help-modal-content">
                            <div className="icon-container">
                                <i className="icons icons--icon-help-transfer" />
                                <p className="font-paragraph2">{formatText('otpCode-transferModalText1')}</p>
                                <p className="otp-AlternativeOption-countdown">{countDown}s</p>
                            </div>
                        </div>
                        <div className="form__buttons">
                            <button
                                className="form__button form__button-transparent"
                                onClick={this.handleClickCancelButton}
                            >
                                {formatText('otpCode-helpinfoCancel')}
                            </button>
                            <button
                                className="form__button form__button-secondary"
                                onClick={this.handleClickUnderstandButton}
                            >
                                {formatText('otpCode-helpinfoOk')}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default OTPAlternativeOptionModal;
